import { IsNotEmpty, MaxLength, MinLength } from 'class-validator';

export class PasswordResetRequestDto {
    @IsNotEmpty()
    token: string;
}
